<template>
  <el-card class="box-card">
    <RequestInfoDetail ref="detail" />
    <RequestInfoUpload ref="upload" @uploaded="uploaded" />
    <el-card shadow="hover">
      <el-form :model="ruleForm" :inline="true" ref="ruleForm">
        <el-row :gutter="5">
          <el-col :span="24">
            <el-form-item :label="$t('periodo')" prop="name">
              <el-date-picker v-model="ruleForm.range" type="daterange" align="right" unlink-panels clearable
                range-separator="à" format="dd/MM/yyyy" start-placeholder="Inicio" end-placeholder="Fim"></el-date-picker>
            </el-form-item>
            <el-form-item :label="user.type === '1' || user.type === '3' ? $t('cliente') : $t('filial')" prop="name"
              v-if="user.type !== '5'">
              <CustomerList v-model="ruleForm.customer" v-bind:multiple="true"
                v-bind:customerType="user.type === '2' ? 3 : 0" />
            </el-form-item>
            <el-button size="mini" type="info" @click="fetchRecords()">Filtrar</el-button>&nbsp;
            <RequestInfoMoreFilter ref="moreFilterDialog" v-on:filter="fetchRecords" :userType="user.type" />
            <el-button class="right" type="warning" @click="$router.push({ name: 'post', query: { tab: 'attention' } })">Objetos SRO</el-button>&nbsp;
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <div slot="header" class="clearfix">
      <el-col :lg="4">
        {{ $t("fale-conosco-correios") }}
      </el-col>
      <el-col :lg="20" class="right">
        <el-button icon="el-icon-upload" class="right" type="default" @click="upload()" v-show="user.type === '1'">Planilha</el-button>
        &nbsp;<el-button icon="el-icon-plus" class="right" type="primary" @click="add()">Nova Reclamação</el-button>&nbsp;
        <el-pagination class="right" :page-size="records" background :pager-count="5" @current-change="fetchRecords"
            @size-change="changeSize" :current-page.sync="page" layout="sizes, prev, pager, next" :page-sizes="[
            50, 100, 150, 200, 250, 300, 350, 400, 450, 500, 1000,
          ]" :total="total"></el-pagination>
      </el-col>
    </div>
    <el-container>
      <el-main width="80%">
        <PrepostEdit
          v-if="rowModal.open"
          :tag="rowModal.tag"
          :dialog="rowModal.open"
          :state="'VIEW'"
          tab="edit"
          v-on:close="closeRowModal()"
        />
        <el-table @row-dblclick="openRowModal" :data="tableList" stripe ref="tableList" size="mini" style="width: 100%"
          :default-sort="{ prop: 'name', order: 'ascending' }">
          <el-table-column sortable prop="companyName" v-if="user.type !== '5'"
            :label="user.type !== '2' ? 'Cliente' : 'Filial'">
          </el-table-column>
          <el-table-column width="200" sortable prop="tag" :label="$t('objeto')">
            <template slot-scope="scope">
              <TagLink :tag="scope.row.tag" back="request.info" />
            </template>
          </el-table-column>
          <el-table-column sortable prop="status" :label="$t('status')" />
          <el-table-column prop="protocol" :label="$t('protocolo')" />
          <el-table-column prop="errorMessage" label="Mensagem" />
          <el-table-column prop="createdAt" width="110" :label="$t('data')" sortable />
          <el-table-column label="#">
            <template slot-scope="scope">
              <el-button v-if="scope.row.protocol" type="info" title="Detalhes" icon="el-icon-tickets"
                @click="detail(scope.row.protocol)" circle></el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    </el-container>

  </el-card>
</template>
<script>

import * as chartConfigs from "@/components/Charts/config";
import BarChart from "@/components/Charts/BarChart";
import DoughnutChart from "@/components/Charts/DoughnutChart";

import TagLink from '../views/dashboard/prepost/components/TagLink';
import { RequestInfoService } from "@/services/customers/request.info.services";
import { UserService } from "@/services/users/user.services";
import ComponentStateEnum from "@/xpost/enums/ComponentStateEnum";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import RequestInfoMoreFilter from "./RequestInfoMoreFilter";
import moment from "moment";
import "moment/locale/pt-br";
import RequestInfoStatusTag from "./components/RequestInfoStatusTag.vue";
import RequestInfoDetail from './RequestInfoDetail.vue';
import RequestInfoUpload from './RequestInfoUpload.vue';
import RowModalMixin from "@/xpost/mixins/row-modal";
import PrepostEdit from "@/xpost/views/services/pre.post/PrePostEdit.vue";

export default {
  mixins: [RowModalMixin],
  name: "RequestInfo",
  components: {
    PrepostEdit,
    TagLink,
    CustomerList,
    RequestInfoMoreFilter,
    BarChart,
    DoughnutChart,
    RequestInfoStatusTag,
    RequestInfoDetail,
    RequestInfoUpload,
},
  enums: {
    ComponentStateEnum,
  },
  props: {
    range: Array,
    customer: Array,
    service: String,
    state: ComponentStateEnum,
  },
  computed: {
    size() {
      return `${this.width}px`;
    }
  },
  data() {
    return {
      name: 'home',
      width: 70,
      collapse: true,
      bigBarChart: {
        chartData: {
          datasets: [{
            label: "Quantidade",
            data: [10, 3 , 4],
          }],
          labels: ["No prazo", "Fora do prazo", ""],
        },
        extraOptions: chartConfigs.blueChartOptions,
      },
      tableLate: [{
        color: '#5cb87a',
        label: "Entregre no prazo",
        quantity: 80,
      }, {
        color: '#f56c6c',
        label: "Emtregue em atraso",
        quantity: 40,
      }, {
        color: '#1989fa',
        label: "Está em atraso",
        quantity: 12,
      }],
      tableDaysLate: [{
        days: 1,
        quantity: 80,
      }, {
        days: 2,
        quantity: 40,
      }, {
        days: 3,
        quantity: 12,
      }, {
        days: 4,
        quantity: 12,
      }, {
        days: 5,
        quantity: 12,
      }, {
        days: 6,
        quantity: 12,
      }],
      tableList: [],
      total: 0,
      records: 50,
      page: 1,
      ruleForm: {
        range: [new Date().setDate(new Date().getDate() - 30), new Date()],
        customer: [],
        service: "",
      },
      showplp: true,
      dialog: {
        edit: false,
      },
      print: {
        model: '4',
        warning: true,
        declared: true,
        type: '1',
        dialog: false,
        separator: false,
      },
      id: "",
      formPrepost: {
        object: "",
        contract: "",
        orderservice: "",
        plp: "",
        destinatary: "",
        zipcode: "",
      },
      pricetable: 0,
      courier: 0,
      postedAt: '',
      user: {
        type: "1",
        name: "",
      },
    };
  },
  methods: {
    uploaded(file) {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      console.log('upload', file)
      RequestInfoService.upload(file.file)
        .then((response) => {
          this.$message({
            type: "success",
            message: "Arquivo importado com sucesso!",
          });
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());

    },
    changeSize(size) {
      const vm = this;
      vm.records = size;
      vm.fetchRecords();
    },
    detail(protocol) {
      this.$refs.detail.open(protocol);
    },
    upload() {
      this.$refs.upload.open();
    },
    resize() {
      this.collapse = !this.collapse;
      this.width = this.collapse ? 70 : 170;
    },
    redirect(name) {
      this.name = name;
      this.collapse = true;
    },
    format(percentage) {
      return '' + percentage;
    },
    add() {
      this.$router.push({ name: 'request.info.add' });
    },
    fetchRecords() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      const s = moment(vm.ruleForm.range[0]);
      const f = moment(vm.ruleForm.range[1]);
      const filter = vm.$refs.moreFilterDialog.get();

      RequestInfoService.list(
        vm.ruleForm.customer,
        s.format("YYYY-MM-DD"),
        f.format("YYYY-MM-DD"),
        vm.records,
        vm.page,
        filter.tag,
        filter.status,
      )
        .then((response) => {
          vm.tableList = response.records;
          vm.total = response.total;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    }
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.user.type = response.type;
        vm.user.name = response.name;
        vm.fetchRecords();
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      });
  },
};
</script>

<style>
.el-drawer__body {
  overflow-y: auto !important;
}
</style>